import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import config from 'react-global-configuration';
import { request } from './index';
import moment from 'moment';

/**
 * Feedbacks
 */
export function* loadCategories() {
  try {
    const myUrlWithParams = new URL(
      config.get('connectGWEndpoint') + 'api/v1/feedback-categories'
    );

    const url = myUrlWithParams.href;
    const options = {
      method: 'GET',
      type: 'application/json',
    };
    const response = yield call(request, url, options);

    yield put({
      type: types.CATEGORIES_SUCCESS,
      payload: response,
    });
  } catch (err) {
    console.error('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.CATEGORIES_FAILURE,
      payload: err,
    });
  }
}

function* getUrlForFeedbacks(baseUrl, settings, isFile) {
  const {
    page,
    paging,
    sortBy,
    sortDirection,
    filter,
    withComment,
    withReaction,
    categories,
    dateFrom,
    dateTo,
    rating,
    country,
    type,
    createdBySkodaEmployee,
  } = settings;

  const myUrlWithParams = new URL(baseUrl);
  if (!isFile) {
    myUrlWithParams.searchParams.append('offset', page ? page * paging : 0);
    myUrlWithParams.searchParams.append('limit', paging ? paging : 10);
  }
  myUrlWithParams.searchParams.append('orderBy', sortBy ? sortBy : 'createdAt');
  myUrlWithParams.searchParams.append(
    'sortDirection',
    sortDirection ? sortDirection : 'DESC'
  );
  if (filter) {
    myUrlWithParams.searchParams.append('filter', filter);
  }
  if (country) {
    myUrlWithParams.searchParams.append('countryCode', country);
  }
  if (createdBySkodaEmployee !== undefined) {
    myUrlWithParams.searchParams.append(
      'createdBySkodaEmployee',
      createdBySkodaEmployee
    );
  }
  if (dateFrom) {
    myUrlWithParams.searchParams.append('dateFrom', dateFrom);
  }
  if (dateTo) {
    let date = moment(dateTo).add(1, 'days');
    myUrlWithParams.searchParams.append('dateTo', date.format('yyyy-MM-DD'));
  }
  if (withComment !== null && withComment !== undefined) {
    myUrlWithParams.searchParams.append('withComment', withComment);
  }
  if (withReaction !== null && withReaction !== undefined) {
    myUrlWithParams.searchParams.append('withAdminReaction', withReaction);
  }
  if (rating) {
    myUrlWithParams.searchParams.append('rating', rating);
  }
  if (categories) {
    categories.forEach((category) =>
      myUrlWithParams.searchParams.append('categories', category)
    );
  }
  if (isFile) {
    myUrlWithParams.searchParams.append('format', type.format);
    myUrlWithParams.searchParams.append(
      'languageCode',
      localStorage.getItem('LANGUAGE')
    );
  }
  return myUrlWithParams.href;
}

/**
 * Feedbacks
 */
export function* loadFeedbacks(payload) {
  try {
    const url = yield call(
      getUrlForFeedbacks,
      config.get('connectGWEndpoint') + 'api/v1/feedbacks',
      payload.feedbacks,
      false
    );
    // raw response
    const options = {
      method: 'GET',
      type: 'application/json',
      complete: true,
    };
    const response = yield call(request, url, options);
    const body = yield call([response, response.json]);
    yield put({
      type: types.FEEDBACKS_SUCCESS,
      payload: body,
      header: {
        count: parseInt(response.headers.get('X-Filtered-Count')),
        total: parseInt(response.headers.get('X-Total-Count')),
      },
    });
  } catch (err) {
    console.error('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.FEEDBACKS_FAILURE,
      payload: err,
    });
  }
}

/**
 * Feedbacks
 */
export function* loadFeedbacksExport(payload) {
  try {
    const url = yield call(
      getUrlForFeedbacks,
      config.get('connectGWEndpoint') + 'api/v1/feedbacks/export',
      payload.feedbacks,
      true
    );

    // raw response
    const options = {
      method: 'GET',
      type: payload.feedbacks.type.content,
    };
    const response = yield call(request, url, options);
    yield put({
      type: types.FEEDBACKS_EXPORT_SUCCESS,
      payload: response,
    });
  } catch (err) {
    console.error('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.FEEDBACKS_EXPORT_FAILURE,
      payload: err,
    });
  }
}

/**
 * Attachment
 */
export function* loadFeedbacksAttachment(payload) {
  try {
    const url = payload.attachment.url;
    // raw response
    const options = {
      method: 'GET',
      type: payload.attachment.contentType,
    };
    const response = yield call(request, url, options);
    yield put({
      type: types.FEEDBACKS_ATTACHMENT_SUCCESS,
      payload: response,
    });
  } catch (err) {
    console.error('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.FEEDBACKS_ATTACHMENT_FAILURE,
      payload: err,
    });
  }
}

/**
 * Reaction
 */
export function* saveReaction(payload) {
  try {
    const myUrlWithParams = new URL(
      config.get('connectGWEndpoint') +
        'api/v1/feedbacks/' +
        payload.reaction.id +
        '/reaction'
    );

    const url = myUrlWithParams.href;
    // raw response
    const options = {
      method: 'PUT',
      type: 'text/plain',
      body: JSON.stringify({ value: payload.reaction.value }),
    };
    yield call(request, url, options);
    yield put({
      type: types.REACTION_SAVE_SUCCESS,
      payload: { id: payload.reaction.id, value: payload.reaction.value },
    });
  } catch (err) {
    console.error('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.REACTION_SAVE_FAILURE,
      payload: err,
    });
  }
}

/**
 * Delete reaction
 */
export function* deleteReaction(payload) {
  try {
    const myUrlWithParams = new URL(
      config.get('connectGWEndpoint') +
        'api/v1/feedbacks/' +
        payload.reaction.id +
        '/reaction'
    );

    const url = myUrlWithParams.href;
    // raw response
    const options = {
      method: 'PUT',
      type: 'text/plain',
      body: JSON.stringify({ value: '' }),
    };
    yield call(request, url, options);
    yield put({
      type: types.REACTION_DELETE_SUCCESS,
      payload: payload.reaction.id,
    });
  } catch (err) {
    console.error('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.REACTION_DELETE_FAILURE,
      payload: err,
    });
  }
}

/**
 * Delete feedback
 */
export function* deleteFeedback(payload) {
  try {
    const myUrlWithParams = new URL(
      config.get('connectGWEndpoint') +
        'api/v1/feedbacks?ids=' +
        payload.feedback.id
    );

    const url = myUrlWithParams.href;
    // raw response
    const options = {
      method: 'DELETE',
      type: 'application/json',
    };
    yield call(request, url, options);
    yield put({
      type: types.FEEDBACK_DELETE_SUCCESS,
      payload: payload.feedback.id,
    });
  } catch (err) {
    console.error('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.FEEDBACK_DELETE_FAILURE,
      payload: err,
    });
  }
}

/**
 * Feedback
 */
export function* changeCategory(payload) {
  try {
    const myUrlWithParams = new URL(
      config.get('connectGWEndpoint') +
        'api/v1/feedbacks/' +
        payload.category.id +
        '/category'
    );

    const url = myUrlWithParams.href;
    // raw response
    const options = {
      method: 'PUT',
      type: 'text/plain',
      body: JSON.stringify({ categoryCode: payload.category.value }),
    };
    yield call(request, url, options);
    yield put({
      type: types.CHANGE_CATEGORY_SUCCESS,
      payload: { id: payload.category.id, value: payload.category.value },
    });
  } catch (err) {
    console.error('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.CHANGE_CATEGORY_FAILURE,
      payload: err,
    });
  }
}

/**
 * Feedback
 */
export function* sendToCask(payload) {
  try {
    const myUrlWithParams = new URL(
      config.get('connectGWEndpoint') +
        'api/v1/feedbacks/' +
        payload.feedback.id +
        '/operation-request/sendToCask'
    );

    const url = myUrlWithParams.href;
    const options = {
      method: 'POST',
      type: 'text/plain',
    };
    yield call(request, url, options);
    yield put({
      type: types.FEEDBACK_SEND_SUCCESS,
      payload: payload.feedback.id,
    });
  } catch (err) {
    console.error('error', err);
    /* istanbul ignore next */
    yield put({
      type: types.FEEDBACK_SEND_FAILURE,
      payload: err,
    });
  }
}

/**
 * Feedback Sagas
 */
export default function* root() {
  yield all([
    takeLatest(types.CATEGORIES_LOADING, loadCategories),
    takeLatest(types.FEEDBACKS_LOADING, loadFeedbacks),
    takeLatest(types.FEEDBACKS_EXPORT_LOADING, loadFeedbacksExport),
    takeLatest(types.FEEDBACKS_ATTACHMENT_LOADING, loadFeedbacksAttachment),
    takeLatest(types.REACTION_SAVE_REQUEST, saveReaction),
    takeLatest(types.REACTION_DELETE_REQUEST, deleteReaction),
    takeLatest(types.FEEDBACK_DELETE_REQUEST, deleteFeedback),
    takeLatest(types.CHANGE_CATEGORY_REQUEST, changeCategory),
    takeLatest(types.FEEDBACK_SEND_REQUEST, sendToCask),
  ]);
}
